import { ClickEvent, Component, DataDisplayEvent, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { ModelRow } from "@mcleod/core";
import { LogicBrokeragePlanningPerformance } from "./LogicBrokeragePlanningPerformance";
import { BrokeragePlanningPerformance } from "./widgets/BrokeragePlanningPerformance";
import {
    AutogenLayoutBrokeragePlanningPerformanceBuyToMarket
} from "./autogen/AutogenLayoutBrokeragePlanningPerformanceBuyToMarket";

export class BrokeragePlanningPerformanceBuyToMarket extends AutogenLayoutBrokeragePlanningPerformanceBuyToMarket {
    public perfHeaderRow: ModelRow;
    private brokeragePlanningPerformance: BrokeragePlanningPerformance;

    onLoad() {
        this.chartBuyToMarket.renderDefaultData = false;
        this.brokeragePlanningPerformance = this.owner as BrokeragePlanningPerformance;
    }

    /** This is an event handler for the onDisplay event of sourceBPPerfBuyToMarket.  */
    sourceBPPerfBuyToMarketOnDisplay(event: DataDisplayEvent) {
        LogicBrokeragePlanningPerformance.setTableColumnHeaders(this.tableBPPerfBuyToMarket, this.perfHeaderRow);
        const brokerageStatusesToChart = ["Covered", "In Progress", "Delivered", "Total"];
        LogicBrokeragePlanningPerformance.createChartData(this.tableBPPerfBuyToMarket, this.chartBuyToMarket, this.mainDataSource.data, this.perfHeaderRow, brokerageStatusesToChart);
        this.chartBuyToMarket.renderChart();
    }

    /** This is an event handler for the onDataDisplay event of tableBPPerfBuyToMarket.  */
    tableBPPerfBuyToMarketOnRowDisplay(event: TableRowDisplayEvent) {
        const percentValuePresent = event.target.data.get("day_0_percent", null) != null;
        const tableRow = event.target as TableRow;
        tableRow.forEveryChildComponent((component: Component) => {
            const field = component.field;
            if (field) {
                if (!(field.startsWith("day_") || field.startsWith("total")))
                    return;
                if (!field.endsWith("_percent")) {
                    component.color = component.getDataValue()?.amount > 0 ? "error" : "default";
                }
                else {
                    component.color = component.getDataValue() > 100 ? "error" : "primary";
                }
                component.visible = (field.endsWith("_percent") && percentValuePresent) || (!field.endsWith("_percent") && !percentValuePresent);
            }
        });
    }

    cellLabelOnClick(event: ClickEvent) {
        LogicBrokeragePlanningPerformance.cellLabelOnClick(event, this.perfHeaderRow, this.brokeragePlanningPerformance.currentProfile, "&excludeBuyToMarket=true");
    }
}
